module.exports = __webpack_public_path__ + "static/media/2_Open-Home-app.a13b5e49.svg";